module.exports = __webpack_public_path__ + "img/portrait-043.ce083e56.jpg";